import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api, unwrap } from '../api';
import { imageSrcSet, imageUrl } from '../api/image';
import NotFoundPage from './NotFoundPage';

/** `/series/:seriesId`: one series and its episodes from `GET /v1/series/{id}` (id or slug). */
const SeriesPage = () => {
  const { seriesId } = useParams();
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    let cancelled = false;
    setState({ loading: true });
    unwrap(api.GET('/v1/series/{id}', { params: { path: { id: seriesId } } }))
      .then(({ data }) => !cancelled && setState({ series: data }))
      .catch(error => !cancelled && setState({ notFound: error.code === 'NOT_FOUND', error }));
    return () => {
      cancelled = true;
    };
  }, [seriesId]);

  if (state.loading) {
    return <div className="min-h-screen bg-primary" aria-busy="true" />;
  }
  if (state.notFound) {
    return <NotFoundPage />;
  }
  if (!state.series) {
    return (
      <div className="min-h-screen bg-primary text-white p-10 text-center">
        We couldn&apos;t load this series right now. Please try again.
      </div>
    );
  }

  const { series } = state;
  const episodes = series.episodes?.items || [];
  return (
    <div className="min-h-screen bg-primary text-white">
      <div className="container mx-auto px-6 py-10">
        <h1 className="text-3xl md:text-4xl font-display uppercase tracking-wide mb-8">
          {series.name}
        </h1>
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {episodes.map(ep => (
            <li key={ep.id}>
              <Link to={`/watch/${ep.slug || ep.id}`} className="block group">
                {ep.art?.landscape && (
                  <img
                    src={imageUrl(ep.art.landscape, '16x9', 640)}
                    srcSet={imageSrcSet(ep.art.landscape, '16x9', 960)}
                    sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
                    alt=""
                    className="w-full aspect-video object-cover rounded-lg"
                  />
                )}
                <p className="mt-2 font-heading uppercase tracking-wide group-hover:text-accent">
                  {ep.title?.value || ep.slug}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SeriesPage;
